import { TELETOLK } from '@/constants';

export default string => string.includes(TELETOLK);
